import { FC } from 'react';
import { css } from 'styled-components';
//SDS
import Container from 'saur-design-sys-web/lib/Atoms/Container/Container';
import Word from 'saur-design-sys-web/lib/Atoms/Word/Word';
import { ThemeType } from 'saur-design-sys-web/lib/BrandsConfig';
import { RouteTypes, usePath } from '../../../common/navigation';
import ExternalAppsIcon from 'saur-design-sys-web/lib/Icons/ApplicationsIcon';
import { Claim } from 'saur-viseau-state-management/lib/settings/state';

//Internal
import { useTranslation } from 'react-i18next';
import Accordion from '../../Accordion';
import CustomLink from '../../CustomLink';
import useExternalApplications from '../hooks/useExternalApplications';

type IProps = {
    claims: Claim[]
};

const SecondaryMenuItem: FC<IProps> = ({claims}) => {
    const { getPath } = usePath();
    const {
        getExternApplications,
        openExternalApp
    } = useExternalApplications();
    const { t } = useTranslation();

    const externApplications = getExternApplications();

    return (
        <>
            {externApplications?.length > 0 && (
                <>
                    <Container className='hr' />
                    <Accordion
                        leftIcon={<ExternalAppsIcon />}
                        title={t('menu.externalApps')}
                    >
                        <Container className='secondary-menu-item-container'>   
                            {
                                externApplications
                                .filter(({name}) => name !== "Fiche Client")
                                .map(({ name, redirectUrl, isAlive }) => (
                                    <CustomLink
                                        key={name}
                                        automatedTestId={name}
                                        to={redirectUrl}
                                        isExternalLink={true}
                                        onClick={() => openExternalApp(name)}
                                    >
                                        <Container className='menu-text-container-warning'>
                                            <Word
                                                value={name}
                                                textStyle='normalMed'
                                                className='menu-text'
                                            />
                                            {
                                                !isAlive &&
                                                <Container >
                                                    <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f79f00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
                                                </Container>
                                            }
                                        </Container>
                                    </CustomLink>
                                ))
                            }
                            {
                                externApplications.find(({name}) => name === "Fiche Client") &&
                                claims.find(({ code }) => code === "ACCESS_FICHE_CLIENT_V2") &&
                                    <CustomLink
                                        automatedTestId={"fiche-client-v2"}
                                        to={getPath(RouteTypes.FICHE_CLIENT)}
                                        isExternalLink={false}
                                    >
                                        <Word
                                            value={"Fiche Client"}
                                            textStyle='normalMed'
                                            className='menu-text'
                                        />
                                    </CustomLink>
                            }
                        </Container>
                    </Accordion>
                </>
            )}
            
        </>
    );
};
export default SecondaryMenuItem;

//Style
const AccordionStyles = css`

    .menu-text-container-warning {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
    }
    .accordion-container {
        margin-top: 14px;
        padding: 8px 12px;
        width: auto;

        .accordion-header {
            display: flex;
            flex-direction: row;
            gap: 1rem;
            align-items: start;
            justify-content: start;
            align-items: center;

            cursor: pointer;
            .accordion-header_Left-icon {
                height: 30px;
                width: 30px;
                justify-content: center;
                align-items: center;
                svg path {
                    fill: ${(props: ThemeType) => props.theme.texts.menuText};
                }
            }
            .accordion-header_title {
                color: ${(props: ThemeType) => props.theme.texts.menuText};
            }
            .accordion-header_arrow-icon {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                height: 100%;
                width: 0.8rem;
                transform: rotate(0deg);
                transition: transform 0.7s;
                svg path {
                    fill: ${(props: ThemeType) => props.theme.texts.menuText};
                }
                &.open {
                    transform: rotate(180deg);
                }
            }
        }
        .accordion-content {
            padding: 1rem;
            padding-top: 0;
            transition: all 0.7s;
            display: block;
            margin-top: 1rem;
        }
    }
`;

export const SecondaryMenuItemStyles = css`
    .secondary-menu-item-container {
        flex-direction: column;
        margin-left: 18px;
    }
    ${AccordionStyles}
`;
